import { chat, usersGreen } from "@/constants";
import { Button } from "../ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

import { useEffect, useState } from "react";
import ChatRoom from "./ChatRoom";
import { UserProfile } from "@/types";
import useChatSocketStore from "@/stores/socket/chat.store";

export interface ChatBarProps {
  isOpen: boolean;
  handleClose: () => void;
}

const ChatBar = ({ isOpen, handleClose }: ChatBarProps) => {
  const [activeUserCount, setActiveUserCount] = useState<number>(0);
  const [onlineUserProfiles, setOnlineUserProfiles] = useState<UserProfile[]>(
    [],
  );

  const { socket } = useChatSocketStore();

  useEffect(() => {
    // Ensure socket exists before setting up event listeners
    if (socket) {
      // Define event handlers
      const handleOnlineUsers = (data: string[]) => {
        // setActiveUserCount(data.length);
      };

      const handleOnlineUserProfiles = (data: UserProfile[]) => {
        setOnlineUserProfiles(data);
        setActiveUserCount(data.length);
      };

      // Attach event listeners
      socket.on("onlineUsers", handleOnlineUsers);
      socket.on("onlineUserProfiles", handleOnlineUserProfiles);

      // Cleanup function to remove event listeners
      return () => {
        socket.off("onlineUsers", handleOnlineUsers);
        socket.off("onlineUserProfiles", handleOnlineUserProfiles);
      };
    }
  }, [socket, setActiveUserCount]);

  return (
    <>
      <div className="sticky top-[80px] hidden min-h-[calc(100vh-80px)] min-w-[89px] overflow-hidden border-l border-white/10 bg-[#020012]">
        <div className="flex w-full flex-col items-center">
          <div className="flex h-[74px] w-full items-center justify-center border-b border-white/10 bg-[linear-gradient(90deg,#00D3A7_0%,#294CFF_100%)]">
            <Button
              onClick={handleClose}
              className={`size-[42px] bg-[#02082B] p-2`}
            >
              <img src={chat} alt="chat" className="mt-1 min-h-5 min-w-5" />
            </Button>
          </div>

          <div className="mx-3 my-5 flex items-center justify-center rounded-lg bg-[#20203C] px-3 py-2">
            <img src={usersGreen} alt="people" className="mr-[6px] size-4" />
            <span className="font-medium leading-5 text-[#33FF3B]">
              {activeUserCount}
            </span>
          </div>

          <hr className="h-[1px] w-[70%] bg-white opacity-10" />

          {/* users */}
          <div className="mt-4 flex flex-col gap-2">
            {onlineUserProfiles.slice(0, 7).map((user) => (
              <div className="relative" key={user.id}>
                <div className="absolute right-0 top-0 z-10">
                  <div className="flex h-3 w-3 items-center justify-center rounded-full bg-[#020012]">
                    <div className="inline-flex h-2 w-2 rounded-full bg-[#33FF3B]"></div>
                  </div>
                </div>
                <Avatar className={`z-0 mr-1 mt-1 size-[44px] rounded-lg`}>
                  <AvatarImage
                    src={user.profilePicture}
                    className="h-full w-full rounded-lg"
                  />
                  <AvatarFallback className="text-xs">CN</AvatarFallback>
                </Avatar>
              </div>
            ))}
          </div>
        </div>
      </div>
      <ChatRoom isOpen={isOpen} handleClose={handleClose} />
    </>
  );
};

export default ChatBar;
